export enum AddonTypes {
  OBTAIN_REVIEW = "obtain_review",
  REFERRAL = "referral",
  CUSTOM_CAMPAIGNS = "custom_campaigns"
}
